/** Guias para pagar: vencidas, da semana, mais adiante e pagas. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { Guias } from '../telas/portal/guias';

export const Route = createFileRoute('/portal/guias')({ component: () => <ComPortal>{(d) => <Guias d={d} />}</ComPortal> });
